import {Injectable} from '@angular/core';
import {FromShipping, Shipping} from '../models/shipping';
import { Contact } from '../../shared/models/contact';
import {DateFormatService} from '../../shared/services/date-format.service';

@Injectable({
  providedIn: 'root'
})
export class ShippingMapperService {

  constructor(private dateFormatService: DateFormatService) {}

  formToDb(data: FromShipping): Shipping {
    return  {
      'type': data.sendingType.type.id,
      'site': {
        'office': data.billing.office.id,
        'uuid': data.general.siteUuid,
        'id': data.general.siteId,
        'name': data.general.siteName,
      },
      'client': {
        'uuid': data.general.clientUuid,
        'name': data.general.clientName,
      },
      'shipment': {
        'id': data.sendingType.type.id,
      },
      'transporter': {
        'id': data.sendingType.transporter.id,
        'name': data.sendingType.transporter.name,
      },
      'tracking': data.sendingType.tracking,
      'pickupDate': data.sendingType.pickupDate,
      'deliveryDate': data.sendingType.deliveryDate,
      'deliveryStatus': data.sendingType.deliveryStatus,
      'analyticCode': data.billing.analyticCode.id,
      'name': data.sendingType.name,
      'tax': data.billing.tax,
      'cost': data.billing.cost,
      'invoice': data.billing.invoice,
      'office': data.billing.office.id,
      'comments': data.misc.commentsForm.comments,
      'uuid': data.uuid,
      'isSaveAddress':  data.address.isSaveAddress,
      'contact': !data.general.siteUuid ? this.contactToDB(data.contact) : null ,
      'address': !data.general.siteUuid ? this.addressToDB(data.address) : null ,

      }
  }

  // tslint:disable-next-line:no-any
  addressToDB(subForm: any): any {
    return {
      addressType: subForm.addressType,
      city: subForm.city,
      country: subForm.countryForm.name,
      id: subForm.id,
      line1: subForm.line1,
      line2: subForm.line2,
      line3: subForm.line3,
      name: subForm.name,
      state: subForm.state,
      uuid: subForm.uuid,
      zip: subForm.zip
    };
  }

  // tslint:disable-next-line:no-any
  contactToDB(subForm: any): any {
    return {
      email: subForm.email,
      id: subForm.id,
      name: subForm.name,
      phone: subForm.phone,
      surname: subForm.surname,
      uuid: subForm.uuid,
      mobile: subForm.mobile,
      department: subForm.department,
    };
  }
  // tslint:disable-next-line:no-any
  DBToAddress(subForm: any): any {
    return {
      addressType: subForm.address.addressType,
      city: subForm.address.city,
      country: subForm.address.country,
      id: subForm.address.id,
      line1: subForm.address.line1,
      line2: subForm.address.line2,
      line3: subForm.address.line3,
      name: subForm.address.name,
      state: subForm.address.state,
      uuid: subForm.address.uuid,
      zip: subForm.address.zip,
      isSaveAddress:  subForm.isSaveAddress,
    };
  }

  dbToForm(data: Shipping): FromShipping {
    return {
      address: (data.site && data.site.address)  ? data.site.address : this.DBToAddress(data),
      general : {
        clientUuid: data.client ? data.client.uuid : null,
        clientName: data.client ? data.client.name : null ,
        siteUuid: data.site ?  data.site.uuid : null,
        siteName: data.site ? data.site.name : null ,
    },
      contact: (data.site && data.site.contact) ? this.contactToForm(data.site.contact) : this.contactToForm(data.contact) ,
      sendingType: {
      type: { id: data.type ? data.type : null},
      transporter: { id: data.transporter ? data.transporter.id : null,
                     name: data.transporter ? data.transporter.name : null},
      name: data.name ? data.name : null,
      tracking: data.tracking ? data.tracking : null,
      deliveryDate: data.deliveryDate ? data.deliveryDate : null,
      deliveryStatus: data.deliveryStatus ?  data.deliveryStatus  : null,
      pickupDate: data.pickupDate ? data.pickupDate : null ,
    },
      billing: {
      cost: data.cost ? data.cost : null ,
      tax: data.tax ? data.tax : null ,
      analyticCode: {
        id: data.analyticCode ? data.analyticCode : null ,
        name: data.analyticCode ? data.analyticCode : null ,
      },
      office: { id: data.office ? data.office : null },
      invoice: data.invoice ? data.invoice : null,
    },
      uuid: data.uuid,
      misc: {
        byForm: {
          createdBy: data.createdBy.name  + '   ' + this.dateFormatService.stringToFullDateTime(data.created),
          updatedBy: data.updatedBy.name  + '   ' + this.dateFormatService.stringToFullDateTime(data.updated),
        },
        commentsForm: {
          commentsBlog: data.comments ? data.comments : null,
          comments: data.comments ? data.comments : null,
        },
      }
    }
  }

  contactToForm(data: Contact | null): Contact {
    return {
      'surname' : data ? data.surname : null,
      'email' : data ? data.email : null,
      'culture' : data ? data.culture : null,
      'sex' : data ? data.sex : null,
      'department' : data ? data.department : null,
      'phone' : data ? data.phone : null,
      'mobile' : data ? data.mobile : null,
      'fax' : data ? data.fax : null,
      'skype' : data ? data.skype : null,
      'uuid' : data ? data.uuid : null,
      'created' : data ? data.created : null,
      'updated' : data ? data.updated : null,
      'id' : data ? data.id : null,
      'name' : data ? data.name : null,
    }
  }


}
